import { useContextSelector } from 'use-context-selector';
import { AirSearchResponse } from 'obt-common/types/api/v1/obt/air/air_search_response';
import { ApiProviderContext } from '../FareListItinerariesApiProvider/Context';

export function useAirSelectedItinerariesResponse(): AirSearchResponse[] {
  return useContextSelector(ApiProviderContext, (state) => state.airSelectedItineraries);
}
